module.exports = __webpack_public_path__ + "img/SKMJ_cap3.5c7720b2.jpg";